import "../index.js";
import type {NexusResult, OttoNexus} from "@otto-ec/global-resources/nexus";
import {apps} from "../index.js";

export type WebviewRaw = {
    /**
 *
 */
    openUrlInCustomBrowserTab(url: URL): NexusResult<Promise<void>>;
    /**
 *
 *
 *
 */
    loadUrl(url: URL): NexusResult<Promise<void>>;
    /**
 *
 */
    flushCookies(): void;
}

export type Webview = OttoNexus["apps"]["webview"]

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const webview: Webview = apps.webview;

/**
 *
 */
export const openUrlInCustomBrowserTab: Webview["openUrlInCustomBrowserTab"] = webview.openUrlInCustomBrowserTab;

/**
 *
 */
export const loadUrl: Webview["loadUrl"] = webview.loadUrl;

/**
 *
 */
export const flushCookies: Webview["flushCookies"] = webview.flushCookies;